import { useEffect, useState } from "react";
import {
  getConnectivity,
  startConnectivityWatch,
  subscribeConnectivity,
  type Connectivity,
} from "@/app-bridge/core/connectivity";

const SSR_VALUE: Connectivity = {
  state: "online",
  networkType: null,
  attempts: 0,
  nextRetryAt: null,
  latencyMs: null,
  lastOfflineAt: null,
};

/** Uppkopplingsstatus som väger ihop webbläsare, app och vår egen server. */
export function useConnectivity(): Connectivity {
  const [value, setValue] = useState<Connectivity>(SSR_VALUE);

  useEffect(() => {
    startConnectivityWatch();
    setValue(getConnectivity());
    return subscribeConnectivity(setValue);
  }, []);

  return value;
}
